// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"145":"1a81069c","191":"c43f0a23","392":"e807e557","759":"2a7c68a1","842":"6859072e","895":"5d7f89f5"}[chunkId] + ".css";
};